import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe to format MongoDB coordinates for display in the UI
 * MongoDB stores coordinates as [longitude, latitude]
 * For display/readability, we typically want [latitude, longitude]
 */
@Pipe({
  name: 'formatCoordinates',
  standalone: true
})
export class FormatCoordinatesPipe implements PipeTransform {

  /**
   * Transforms MongoDB coordinates to a display-friendly string
   * 
   * @param coordinates - The coordinates from MongoDB [longitude, latitude]
   * @param format - Output format ('display' for latitude,longitude or 'mongo' for longitude,latitude)
   * @returns Formatted coordinates string
   */
  transform(coordinates: number[], format: 'display' | 'mongo' = 'display'): string {
    if (!coordinates || coordinates.length !== 2) {
      return 'Invalid coordinates';
    }

    if (format === 'display') {
      // For display, we want [latitude, longitude] (swapped from MongoDB)
      return `${coordinates[1]}, ${coordinates[0]}`;
    } else {
      // MongoDB original format [longitude, latitude]
      return `${coordinates[0]}, ${coordinates[1]}`;
    }
  }
}
